var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11237_1791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26562 0.5H0.703125C0.314812 0.5 0 0.814812 0 1.20312V2.84375H7.96875V1.20312C7.96875 0.814812 7.65394 0.5 7.26562 0.5ZM23.6467 7.20261C23.5394 7.14102 23.4177 7.10886 23.2939 7.10937C23.1702 7.10989 23.0488 7.14307 22.9419 7.20556L15.9844 11.2743V7.8125C15.9844 7.68875 15.9517 7.56719 15.8897 7.4601C15.8276 7.35302 15.7385 7.2642 15.6311 7.20262C15.5238 7.14104 15.4021 7.10889 15.2783 7.10941C15.1546 7.10992 15.0331 7.14309 14.9263 7.20556L7.96875 11.2743V4.25H0V23.7969C0 24.1852 0.314812 24.5 0.703125 24.5H23.2969C23.6852 24.5 24 24.1852 24 23.7969V7.8125C24 7.68875 23.9673 7.56718 23.9053 7.4601C23.8433 7.35301 23.7541 7.26419 23.6467 7.20261ZM10.7812 19.5547C10.7812 19.943 10.4664 20.2578 10.0781 20.2578H7.26562C6.87731 20.2578 6.5625 19.943 6.5625 19.5547V16.7422C6.5625 16.3539 6.87731 16.0391 7.26562 16.0391H10.0781C10.4664 16.0391 10.7812 16.3539 10.7812 16.7422V19.5547ZM18.7969 19.5547C18.7969 19.943 18.4821 20.2578 18.0938 20.2578H15.2812C14.8929 20.2578 14.5781 19.943 14.5781 19.5547V16.7422C14.5781 16.3539 14.8929 16.0391 15.2812 16.0391H18.0938C18.4821 16.0391 18.7969 16.3539 18.7969 16.7422V19.5547Z",
    fill: "#43C1F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11237_1791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.783bc93f6e1a8de2fe19edb6767f2ab8.svg";
export { ForwardRef as ReactComponent };